import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Input } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import ContentHeader from "../../../components/shared/ContentHeader";
import BranchTable from "./Table";
import AddEditBranchModal from "./AddEditModal";
import { useTenantBranches } from "../../../hooks/useTenantBranches";
import { useTenantUsers } from "../../../hooks/useTenantUsers";

const BranchManagement = () => {
  const [editingBranch, setEditingBranch] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const { branches: fetchedBranches, loading } = useTenantBranches();
  const { usersOptions, users } = useTenantUsers();

  const showModal = useCallback((branch = null) => {
    //@ts-ignore
    setEditingBranch(branch || {});
  }, []);

  const handleCancel = useCallback(() => {
    setEditingBranch(null);
  }, []);

  const branches = useMemo(() => {
    return fetchedBranches.map((b) => ({
      ...b,
      branchManger: users?.find(({ id }) => id === b?.branch_manager_id),
    }));
  }, [users, fetchedBranches]);

  const mainBranchExists = useMemo(
    () => branches?.some((branch) => branch.is_main_branch),
    [branches]
  );

  const filteredBranches = useMemo(
    () =>
      branches.filter(({ name }) =>
        name.toLowerCase().includes(searchTerm.toLowerCase())
      ),
    [branches, searchTerm]
  );

  return (
    <div>
      <ContentHeader title={"Branch Management"}>
        <Input
          placeholder="Search branches..."
          prefix={<SearchOutlined />}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Button
          type="primary"
          className="add-btn"
          icon={<PlusOutlined />}
          onClick={() => showModal()}
        />
      </ContentHeader>
      <BranchTable
        branches={filteredBranches}
        showModal={showModal}
        loading={loading}
      />
      {editingBranch && (
        <AddEditBranchModal
          editingBranch={editingBranch}
          handleCancel={handleCancel}
          mainBranchExists={mainBranchExists}
          usersOptions={usersOptions}
        />
      )}
    </div>
  );
};

export default BranchManagement;
